import { render } from "./AgendaActivityList.vue?vue&type=template&id=2e5abc2f&scoped=true"
import script from "./AgendaActivityList.vue?vue&type=script&lang=js"
export * from "./AgendaActivityList.vue?vue&type=script&lang=js"

import "./AgendaActivityList.vue?vue&type=style&index=0&id=2e5abc2f&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5abc2f"]])

export default __exports__